const fortuneWheelPrizeDefaultTemplate = {
  id: '',
  label: 'Shirt',
  value: '',
  weight: 10,
}

const prizesTemplate = {
  label: [
    'Shirt',
    'Free Bucket',
    'Watch',
    'Jeans',
    'Prize',
    'Shoes',
    'Rocket',
    'Tesla',
    'Wakeboard',
    'Retro Car',
    'Tickets',
    'Prize',
  ],
  value: [
    'CODE-SHIRT',
    'CODE-FREE-BUCKET',
    'CODE-WATCH',
    'CODE-JEANS',
    'CODE-PRIZE',
    'CODE-SHOES',
    'CODE-ROCKET',
    'CODE-TESLA',
    'CODE-WAKEBOARD',
    'CODE-RETRO-CAR',
    'CODE-TICKETS',
    'CODE-PRIZE',
  ],
}

const fortuneWheelWidgetDefaultTemplate = {
  id: '',
  type: 'wheel',
  category: 'hidden',
  content: {
    prizes: (() => {
      const prizesArr = []
      prizesTemplate.label.forEach((prize, index) => {
        const customPrize = JSON.parse(JSON.stringify(fortuneWheelPrizeDefaultTemplate))
        customPrize.id = index
        customPrize.label = prize
        customPrize.value = prizesTemplate.value[index]
        prizesArr.push(customPrize)
      })

      return prizesArr
    })(),
  },
  settings: {
    label: 'Fortune Wheel',
  },
  /*  Keep the styling even in flattened json structure cause vue ease of use */
  styling: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: '400',
    color: 'rgb(255, 255, 255)',
    backgroundColor: 'rgb(252,118,106)',
    secondaryBackgroundColor: 'rgb(91,132,177)',
    justifyContent: 'center',
    borderRadius: '5px',
    borderWidth: '2px',
    borderColor: 'rgb(0, 0, 0)',
  },
}

export { fortuneWheelWidgetDefaultTemplate, fortuneWheelPrizeDefaultTemplate }
